export default {"src":"/komodo/_next/static/media/doge.72895b2c.svg","height":30,"width":107,"blurWidth":0,"blurHeight":0};